import { AIProtonModel } from "@NA/Widgets/AIProton/AIProtonModel";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

export default interface AIProtonState {
    isLoading: boolean;
    products?: AIProtonModel[] | [];
    productsFBT?: AIProtonModel[] | [];
    productsSimilar?: AIProtonModel[] | [];
}

export function createFromProduct(product: AIProtonModel): ProductInfo {
    return {
        productId: product.id,
        qtyOrdered: Math.max(product.minimumOrderQty, 1),
        unitOfMeasure: product.unitOfMeasure,
        productDetailPath: product.productDetailUrl,
    };
}

